import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase'; // make sure path is correct
import { doc, getDoc } from 'firebase/firestore';
import FacebookEventsPage from './FacebookEventsPage'; // adjust if your file path is different

const FacebookEventsPageWrapper = () => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        setRole(userSnap.data().role);
      }
    };

    fetchRole();
  }, []);

  if (!role) return <p>Loading user role...</p>;

  return <FacebookEventsPage userRole={role} />;
};

export default FacebookEventsPageWrapper;
